module.exports = __webpack_public_path__ + "static/media/posterTwo.83b91336.webp";